/** Money arrives from the API as decimal strings; unparsable or absent reads as 0. */
export const parseAmount = (value: string): number => parseFloat(value) || 0
